import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=1105b919&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1105b919')) {
      api.createRecord('1105b919', component.options)
    } else {
      api.reload('1105b919', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=1105b919&", function () {
      api.rerender('1105b919', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/estateManagement/notice/issueNotice/detail.vue"
export default component.exports